import React from "react";
import { Popover } from "@mui/material";

const DSPopover = (props: React.ComponentProps<typeof Popover>) => {
  return <Popover {...props} />;
};

export default DSPopover;
